import '../static/TextLink.css';
import * as React from "react";
import React__default, { forwardRef } from "react";
import clsx from "clsx";
import { b as Button } from "./Button.hIh6dJaA.mjs";
const SvgChevronRight2Px = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, fill: "currentcolor", viewBox: "0 0 20 20", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M6.293 2.293a1 1 0 0 0 0 1.414L12.586 10l-6.293 6.293a1 1 0 1 0 1.414 1.414l7-7a1 1 0 0 0 0-1.414l-7-7a1 1 0 0 0-1.414 0", clipRule: "evenodd" }));
const textLink = `_textLink_d1e3cbe`;
const black = `_black_f247a13`;
const primary = `_primary_437bc0b`;
const textArrowIcon = `_textArrowIcon_9da10ae`;
const textArrowIconLeft = `_textArrowIconLeft_b266e9d`;
const styles = { textLink, black, primary, textArrowIcon, textArrowIconLeft };
const TEXT_LINK_ARROWS = ["left", "right"];
const TEXT_LINK_VARIANTS = ["black", "primary"];
const TextLinkInner = ({ arrow, className, children, variant = "primary", ...props }, ref) => {
  return /* @__PURE__ */ React__default.createElement(
    Button,
    {
      ref,
      variant: "text",
      className: clsx(styles.textLink, styles[variant], className),
      ...props
    },
    arrow === "left" && /* @__PURE__ */ React__default.createElement(
      SvgChevronRight2Px,
      {
        className: clsx(styles.textArrowIcon, styles.textArrowIconLeft),
        "data-testid": "left-arrow"
      }
    ),
    children,
    arrow === "right" && /* @__PURE__ */ React__default.createElement(SvgChevronRight2Px, { className: styles.textArrowIcon, "data-testid": "right-arrow" })
  );
};
const TextLink = forwardRef(
  TextLinkInner
);
export {
  TEXT_LINK_ARROWS as T,
  TEXT_LINK_VARIANTS as a,
  TextLink as b
};
//# sourceMappingURL=TextLink.gdbulXZb.mjs.map
